import { _ as _defineProperty } from '../../unsorted/defineProperty.js';
import { _ as _objectWithoutProperties } from '../../unsorted/objectWithoutProperties.js';
import { m as merge } from '../../unsorted/index.js';
import { jsx } from '@emotion/react/jsx-runtime';
import '@emotion/react';
import { A as AspectRatioImage } from '../AspectRatioImage/AspectRatioImage.js';
import { i as isImageResizerProps } from '../../utils/imageHelpers2.js';

var _excluded = ["sx", "testId", "circularFrame", "className", "use"],
  _excluded2 = ["responsiveSizes"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function FramedImage(_ref) {
  var _ref$sx = _ref.sx,
    sx = _ref$sx === void 0 ? {} : _ref$sx,
    testId = _ref.testId,
    _ref$circularFrame = _ref.circularFrame,
    circularFrame = _ref$circularFrame === void 0 ? false : _ref$circularFrame,
    className = _ref.className,
    use = _ref.use,
    props = _objectWithoutProperties(_ref, _excluded);
  var _ref2 = isImageResizerProps(use) ? props : _objectSpread(_objectSpread({}, props), {}, {
      responsiveSizes: undefined
    }),
    _ref2$responsiveSizes = _ref2.responsiveSizes,
    responsiveSizes = _ref2$responsiveSizes === void 0 ? [24, 32, 64, 128, 256, 450] : _ref2$responsiveSizes,
    otherProps = _objectWithoutProperties(_ref2, _excluded2);
  var allStyles = merge({
    display: "block",
    bg: "base.color.translucent.standard.100",
    overflow: "hidden",
    borderRadius: circularFrame ? "50%" : "base.borderRadius.x2",
    objectFit: "cover",
    objectPosition: "center",
    "& .AwsResizerImage--defaultImage": {
      objectFit: "cover",
      objectPosition: "center"
    }
  }, sx);
  return jsx(AspectRatioImage, _objectSpread(_objectSpread({}, otherProps), {}, {
    use: use,
    responsiveSizes: responsiveSizes,
    className: "".concat(className !== null && className !== void 0 ? className : "", " FramedImage"),
    aspectRatio: "1:1",
    testId: testId,
    sx: allStyles
  }));
}
FramedImage.displayName = "FramedImage";

export { FramedImage as F };
//# sourceMappingURL=FramedImage.js.map
